'use client';
import React from 'react';
import toast from 'react-hot-toast';
import { subscribeWithEmail } from '@/clients/customer/newsletter-subscribe';
import { useParams } from 'next/navigation';
import { validateEmail } from '@/lib/helpers/functions';
import TermsAndCondition from '../shared/TermsAndCondition';
import { useTranslations } from 'next-intl';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export default function VendorHeroNewsletter() {
  const [email, setEmail] = React.useState<string>('');
  const locale = useParams().locale;
  const t = useTranslations();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleSubscribe = async () => {
    if (!email) {
      toast.error('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      return;
    }
    if (!validateEmail(email)) {
      toast.error('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      return;
    }

    const payload: any = {
      email,
      is_customer_type: false,
    };

    const token = await executeRecaptcha?.('newsletter');
    payload['g-recaptcha-response'] = token;

    toast.loading('Bitte warten...');

    subscribeWithEmail(payload, { ['Accept-Language']: locale })
      .then((res) => {
        toast.success(res.data.message);
        setEmail('');
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };

  return (
    <div className="flex max-w-[80%] flex-col gap-y-[20px]">
      <div className="">
        <input
          aria-label={t('aria.email_for_subscription')}
          type="email"
          placeholder="maxmustermann@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-[110px] border-none bg-white px-[30px] py-[12px] text-h6 text-paragraph shadow-[0px_14px_70px_rgba(0,0,0,0.1)] focus:border-none focus:outline-none focus:ring-0"
        />
      </div>
      <div className="flex flex-col gap-[20px] md:flex-row md:gap-[30px] lg:flex-col xl:flex-row">
        <button
          type="submit"
          onClick={handleSubscribe}
          className="w-fit shrink-0 rounded-[35px] bg-gradient-to-r from-[#F5375C] to-[#C33076] px-[20px] py-[11.5px] text-base text-white transition-colors duration-300 hover:drop-shadow-lg "
        >
          {t('subscribe_now')}
        </button>

        <h2 className="text-h5 font-bold text-title">
          {t('subscribe_text_1')} <br /> {t('subscribe_text_2')}
        </h2>
      </div>

      <div className="">
        <TermsAndCondition
          btnText={t('subscribe_now')}
          lang={locale === 'en-DE' ? 'en' : 'de'}
        />
      </div>
    </div>
  );
}
